import { Helmet } from "react-helmet";

export default function Contact() {
    return (
        <>
            <Helmet>
                <title>Contact Us | WebUtility.online</title>
                <meta
                    name="description"
                    content="Get in touch with the WebUtility.online team. We're here to help with your questions, feedback, and support needs."
                />
                <link rel="canonical" href="https://webutility.online/contact" />
            </Helmet>

            <section className="p-8 max-w-screen-2xl bg-white rounded-xl shadow-lg mb-4 mx-auto text-center">
                <div className="container mx-auto">
                    <h1 className="text-3xl font-bold mb-2">Contact Us</h1>
                    <p className="mb-4">Have questions, feedback, or need support? We'd love to hear from you.</p>

                    <div className="mt-6 text-left max-w-xl mx-auto">
                        <h2 className="text-xl font-semibold mb-2">Email</h2>
                        <p className="mb-4">
                            Reach us directly at:{" "}
                            <a href="mailto:Rp7098979@gmail.com" className="text-blue-600 underline">
                                Rp7098979@gmail.com
                            </a>
                        </p>

                        <h2 className="text-xl font-semibold mb-2">Business Hours</h2>
                        <p className="mb-4">Monday - Friday: 9 AM to 6 PM (IST)</p>

                        <h2 className="text-xl font-semibold mb-2">Location</h2>
                        <p className="mb-4">India (remote service)</p>

                        {/* Optional: Contact Form */}
                        {/* Uncomment below if you're planning to use a form later
                        <h2 className="text-xl font-semibold mb-2">Send a Message</h2>
                        <form className="space-y-4">
                            <input type="text" placeholder="Your Name" className="w-full p-2 border rounded" />
                            <input type="email" placeholder="Your Email" className="w-full p-2 border rounded" />
                            <textarea placeholder="Your Message" className="w-full p-2 border rounded h-32" />
                            <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
                                Send
                            </button>
                        </form>
                        */}
                    </div>
                </div>
            </section>
        </>
    );
}
